import React, { useState, useEffect } from "react";
import Link from "@qlik/qlik/src/components/Link";
import {
    getMicrocopyValueFromKeys,
    getResourceInternalLinkCta,
    appendQueryParamsToExternalUrl,
} from "@qlik/qlik/src/lib/util/helpers";
import { BLOG_PATHNAME } from "@qlik/qlik/src/lib/constants/blog-constants";
import { BLOG_BUTTON_TEXT } from "@qlik/qlik/src/lib/constants/blog-constants";
import { formatDateRange } from "@qlik/qlik/src/lib/util/dates";
import { useLocation } from "@reach/router";
import { useI18n } from "@qlik/utils/i18nContext";

const ResourceNoImage = ({ data }) => {
    const { component, browsingContext } = data ?? {};
    const { i18n } = useI18n();

    const [date, setFormattedDateStr] = useState(null);
    const title = component?.title;

    const target = browsingContext === "New Tab" ? "_blank" : "_self";
    const location = useLocation();
    let linkText = component?.ctaLabel ? component?.ctaLabel : component?.cta?.[0]?.text;
    let type;
    let href;

    useEffect(() => {
        setFormattedDateStr(formatDateRange(component?.startDate, component?.endDate, i18n.curr.langCode));
    }, [component]);

    const resourceUrlObject =
        component?.__typename === "ContentfulResource" ? getResourceInternalLinkCta(component) : {};
    switch (component?.__typename) {
        case "ContentfulBlog":
            href = `/${BLOG_PATHNAME}/${component.slug}`;
            linkText = getMicrocopyValueFromKeys(component?.microcopyGroup, [BLOG_BUTTON_TEXT]);
            break;
        case "ContentfulResource":
            href = i18n.getLangPrefixedPath(resourceUrlObject?.[0]?.internalLink?.slug);
            break;
        case "ContentfulCard":
            href =
                component?.cta && component?.cta?.[0]?.internalLink !== null
                    ? i18n.getLangPrefixedPath(`/${component?.cta?.[0]?.internalLink?.slug}`)
                    : component?.cta?.[0]?.externalUrl;
            break;
        case "ContentfulEvent":
            href =
                component?.cta && component?.cta?.[0]?.internalLink !== null
                    ? i18n.getLangPrefixedPath(`/${component?.cta?.[0]?.internalLink?.slug}`)
                    : appendQueryParamsToExternalUrl(component?.cta?.[0]?.externalUrl, component?.cta?.[0]);
            break;
        default:
            break;
    }

    return (
        <div className="pb-7.5 lg:pb-12.5">
            <Link
                className="z-1 group/link relative flex flex-col pt-3.5 border-t border-gray/25"
                newWindow={browsingContext === "New Tab"}
                to={href ?? "#"}
            >
                <span className="-z-1 absolute -inset-y-2.5 -inset-x-3.75 rounded bg-white shadow-xlSmall opacity-0 transition-opacity transition-300 xl:group-hover/link:opacity-100" />
                {type && (
                    <span className="mb-2.5 text-ocean text-sm font-medium uppercase tracking-wide4 leading-none">
                        {type}
                    </span>
                )}
                {date && (
                    <span className="mb-5 text-gray/50 text-sm font-medium uppercase tracking-wide4 leading-none">
                        {date}
                    </span>
                )}
                {title && (
                    <p className="mb-5 text-gray text-base font-bold tracking-normal leading-none lg:text-md">
                        {title}
                    </p>
                )}
                {linkText && (
                    <span className="green-link xl:group-hover/link:text-dark-green xl:group-hover/link:after:arrow-green-dark xl:group-hover/link:after:translate-x-0.75">
                        {linkText}
                    </span>
                )}
            </Link>
        </div>
    );
};
export default ResourceNoImage;
